<now-footer wide="true"></now-footer>
<now-fallback-footer wide="true" [attr.base-path]="nowPortalBasePath" />
